// EntityMapped.jsx
import { Box, Chip, Grid, Typography, Paper, Avatar } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CheckCircle, Error, Warning, InfoOutlined } from "@mui/icons-material";

import React from "react";

const DocumentCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  boxShadow: theme.shadows[2],
  transition: "transform 0.15s ease-in-out",
  "&:hover": {
    transform: "scale(1.02)",
  },
}));

const EntityMapped = ({ entity }) => {
  if (!entity) return null;

  const getEstadoConfig = (estado) => {
    if (!estado) return { color: "default", icon: null };
    switch (estado.toLowerCase()) {
      case "vigente":
        return { color: "success", icon: <CheckCircle /> };
      case "vencido":
        return { color: "error", icon: <Error /> };
      case "faltan documentos":
        return { color: "default", icon: <InfoOutlined /> };
      default:
        return { color: "warning", icon: <Warning /> };
    }
  };

  return (
    <Grid container spacing={2}>
      {entity?.documentos.map((doc, index) => {
        const { color, icon } = getEstadoConfig(doc?.estado);
        return (
          <Grid item xs={12} key={index}>
            <DocumentCard>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Avatar
                  sx={{
                    bgcolor: `${color}.light`,
                    color: `${color}.dark`,
                    width: 40,
                    height: 40,
                  }}
                >
                  {icon}
                </Avatar>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {doc?.nombre}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Vence: {doc?.fechaVencimiento || "Sin fecha"}
                  </Typography>
                </Box>
              </Box>
              <Chip
                label={doc?.estado || "Sin estado"}
                color={color}
                variant="filled"
                size="small"
              />
            </DocumentCard>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default EntityMapped;
